module.exports = __webpack_public_path__ + "img/P150T_weapon_105.7165b808.png";